module.exports = __webpack_public_path__ + "static/media/bg-mobile.01d44f99.jpg";